/*************************************************/
/* Vue                                           */
/*************************************************/

import { createApp, h } from 'vue';
import { createRouter, createWebHistory } from "vue-router";
import Articles from './vue/articles.vue';


const articlesAppSelector = "#articlesApp";
if (document.querySelector(articlesAppSelector) != null) {
    const articlesNodeId = document.querySelector(articlesAppSelector).dataset.articlesNodeId;
    const pageSize = document.querySelector(articlesAppSelector).dataset.pagesize;
    const whiteSpace = document.querySelector(articlesAppSelector).dataset.whitespace;
    const loadText = document.querySelector(articlesAppSelector).dataset.loadText;
    const hideIndustry = document.querySelector(articlesAppSelector).dataset.hideIndustry;
    const hideSolution = document.querySelector(articlesAppSelector).dataset.hideSolution;
    const hideContentType = document.querySelector(articlesAppSelector).dataset.hideContentType;
    const hideAuthor = document.querySelector(articlesAppSelector).dataset.hideAuthor;
    const hideLocation = document.querySelector(articlesAppSelector).dataset.hideLocation;

    const router = createRouter({
        history: createWebHistory(),
        routes: [{ path: window.location.pathname, component: Articles }]
    });

    const seedData = { articlesNodeId: articlesNodeId, pageSize: pageSize, whiteSpace: whiteSpace, loadText: loadText, hideIndustry: hideIndustry, hideSolution: hideSolution, hideContentType: hideContentType, hideAuthor: hideAuthor, hideLocation: hideLocation};

    const articlesApp = createApp({
        data() { return seedData },
        render: () => h(Articles)
    }, seedData);

    articlesApp.use(router);
    router.isReady().then(() => articlesApp.mount(articlesAppSelector));
}